
import Footer from './Footer';
import Carousel from './Carousel';
import Main from './Main';
// import Navbar2 from '../Components/Navbar2';
import Navbar from "../Components/NewNavbar"


function Home() {



  return (
    <>
      <Navbar/>
      <Carousel />
      <Main />
      <Footer />
    </>
  )
}

export default Home;


